import React, { useState } from 'react';
import { Button, Modal, QRCode, Typography } from 'antd';
import { Download, OpenInBrowser, QrCode2 } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import dataURLtoFile from '../Functions/Traitement/ConvertBase64ToFile';
import Format from '../Functions/Traitement/Format';

function ShowFile(props:{file: string, fileName: string}){
  const [modal2Open, setModal2Open] = useState(false);
  const file : File = dataURLtoFile(props.file, props.fileName)
  function download(){
    var a = document.createElement("a"); //Create <a>
    a.href = props.file; //Image Base64 Goes here
    a.download = file.name; //File name Here
    a.click(); //Downloaded file
  }
  return (
    <>
      <IconButton style={{marginLeft: "20px"}} onClick={() => setModal2Open(true)} sx={{color: "black", marginLeft:"5px"}}><OpenInBrowser/></IconButton>
      <Modal
        centered
        open={modal2Open}
        onOk={() => setModal2Open(false)}
        onCancel={() => setModal2Open(false)}
        footer
        width={"auto"}
        zIndex={9999999999999}
        style={{overflow: "auto", width: 800}}
      >
        <br /><br />
        <Box>
          <Box height={500} width={"100%"}>
            <embed height={"100%"} width={"100%"} src={props.file} />
          </Box>
        </Box><hr />
        <Box alignContent={"space-between"} display={"flex"}>
          <IconButton style={{marginLeft: "20px"}} onClick={download} sx={{color: "black", marginLeft:"5px"}}><Download/></IconButton>
          <Typography className = 'border-left' >{file.name+"."+file.type.split("/")[1]+" - "} <b>{(new Format()).Auto(file.size)}</b></Typography>
        </Box>
        
      </Modal>
    </>
  );
};

export default ShowFile;